export default "__VITE_ASSET__36bf3574__"